import { SITE } from "../data/site";
import { Instagram, MessageCircle, MapPin } from "lucide-react";

const QUICK = [
  { id: "collection", label: "Collection" },
  { id: "best-sellers", label: "Best Sellers" },
  { id: "reviews", label: "Reviews" },
  { id: "locations", label: "Location" },
  { id: "faq", label: "FAQ" },
];

const Footer = () => {
  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid="site-footer"
      className="bg-[hsl(var(--ink))] text-[hsl(var(--cream))] pt-20 pb-10"
    >
      <div className="container-tjb">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img
              src={SITE.logoDark}
              alt={SITE.brand}
              className="h-12 w-auto mb-6"
            />
            <p className="text-sm text-[hsl(var(--cream))]/75 leading-relaxed max-w-md">
              Triple J Bali is a linen-focused fashion boutique in Bali offering
              simple luxury outfits for men and women. Visit us in Canggu or
              Ubud for breathable, elegant pieces made for tropical days.
            </p>
            <div className="flex flex-wrap gap-3 mt-7">
              <a
                href={SITE.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="btn-ghost-light"
              >
                <MessageCircle className="w-4 h-4" /> WhatsApp
              </a>
              <a
                href={SITE.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="btn-ghost-light"
              >
                <Instagram className="w-4 h-4" /> {SITE.instagramHandle}
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow !text-[hsl(var(--cream))]/65 mb-4">Visit</p>
            <a
              href={SITE.cangguMaps}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-canggu-maps"
              className="flex items-start gap-2 text-sm py-2 text-[hsl(var(--cream))]/90 hover:text-[hsl(var(--cream))]"
            >
              <MapPin className="w-4 h-4 mt-0.5" />
              <span>Canggu Store on Google Maps</span>
            </a>
            <a
              href={SITE.ubudMaps}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-ubud-maps"
              className="flex items-start gap-2 text-sm py-2 text-[hsl(var(--cream))]/90 hover:text-[hsl(var(--cream))]"
            >
              <MapPin className="w-4 h-4 mt-0.5" />
              <span>Ubud Store on Google Maps</span>
            </a>
            <p className="mt-4 text-sm text-[hsl(var(--cream))]/75">
              {SITE.hours}
            </p>
          </div>

          <div className="md:col-span-4">
            <p className="eyebrow !text-[hsl(var(--cream))]/65 mb-4">Quick Links</p>
            <div className="grid grid-cols-2 gap-2">
              {QUICK.map((q) => (
                <button
                  key={q.id}
                  data-testid={`footer-link-${q.id}`}
                  onClick={() => go(q.id)}
                  className="text-left text-sm py-1.5 text-[hsl(var(--cream))]/85 hover:text-[hsl(var(--cream))]"
                >
                  {q.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="divider-soft mt-12 opacity-30" />

        <div className="flex flex-col md:flex-row gap-3 justify-between items-center pt-8 pb-4 md:pb-0 md:pr-[200px] text-xs text-[hsl(var(--cream))]/55">
          <p>© {new Date().getFullYear()} {SITE.brand}. All rights reserved.</p>
          <p>Canggu · Ubud · Bali, Indonesia</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
